<template>
  <div
    :title="title"
    class="header-action__button"
    @click="ev => $emit('click', ev)"
    @keydown="ev => $emit('keydown', ev)"
  >
    <slot>
      <i :class="icon" />
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },

    icon: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.header-action__button {
  flex: none;
  font-size: 1.5em;
  line-height: 1em;
  cursor: pointer;
  user-select: none;
  margin-left: 0.625em;
}
</style>
